import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { Component, OnInit } from '@angular/core';
import { CallWorkflowActivity } from 'src/app/models/activities/call-workflow-activity';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout.service';
import { WorkflowApplicationsJanusService } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';

@Component({
    selector: 'wm-call-workflow-view',
    templateUrl: './call-workflow-view.component.html',
    styleUrls: ['./call-workflow-view.component.css'],
    standalone: false
})
export class CallWorkflowViewComponent extends ActivityView implements OnInit {
  callActivity: CallWorkflowActivity;
templateForPermitForm : boolean = false;
summaryViewBGJanus: boolean = true;
showSummary:boolean = false

allowReopenChildInspectionApplicationsParentActivityId : string | null = null;
editApplicationJanusView:boolean = false
  constructor(private router: Router,public layoutService: LayoutService,public workflowApplicationJanusSvc : WorkflowApplicationsJanusService,
    public route: ActivatedRoute,
  ) {
    super();
     layoutService.useNewLayout$.subscribe(useNewLayout => {
      this.templateForPermitForm = useNewLayout;
    });
  }

  launchChildSummary() {
    if (this.callActivity.model.callingWorkflowApplicationId) {
      this.router.navigate([
        '/application/workflow-application-summary',
        this.callActivity.model.callingWorkflowApplicationId
      ]);
    }
  }
  launchJanusChildSummary() {
      if (this.showSummary === false &&  this.callActivity.model.callingWorkflowApplicationId) {
        this.showSummary = true;
      }
    }
  ngOnInit() {
    // check whether workflow applications and view application category
    const currentCategory = this.route.snapshot.queryParamMap.get('c');
    if(this.router.url.includes('workflow-applications') && currentCategory && currentCategory === 'view-application'){
      this.editApplicationJanusView = true;
    }
    this.workflowApplicationJanusSvc.data$.subscribe(data => {
      if(data.inlineApplicationSummaryDetails.categoriesDefined){
        this.summaryViewBGJanus = false;
      }
    });

    this.callActivity = this.activity as CallWorkflowActivity;
    if(this.router.url.includes('workflow-applications') && this.context.applicationViewType==='inline'&& this.workflowApplicationJanusSvc.getData().inlineApplicationSummaryDetails?.categoriesDefined===true && this.route.snapshot.queryParamMap.get('c')!=='view-application'){

      this.allowReopenChildInspectionApplicationsParentActivityId = this.activity.id
    }else{
      this.allowReopenChildInspectionApplicationsParentActivityId = null;
    }
  }
}
